import angular from 'angular';
import moment from 'moment';
import { MeurhTransferenciaColaboradoresService } from '../transferenciacolaboradores.service';
import { ListagemService } from '../../../../shared/services/listagem.service';
import { ITransferenciaColaboradores } from '../models/transferenciacolaboradores.model';
import { Empresa, Estabelecimento } from '../../../../core/usuario/models/usuario-model';

type IMeurhTransferenciaColaboradoresIndexFilter = {
    empresa?: string;
    estabelecimento?: string;
    situacao?: string;
    lotacao?: {
        lotacao: string;
    } | null;
};

export class MeurhTransferenciaColaboradoresIndexController implements angular.IController {
    static $inject = [
        '$rootScope',
        '$scope',
        '$stateParams',
        '$location',
        'NewToaster',
        'MeurhTransferenciaColaboradoresService',
        'ListagemService'
    ];

    public entities: Array<ITransferenciaColaboradores>;
    public filters: IMeurhTransferenciaColaboradoresIndexFilter = {};
    public busy: boolean = false;

    public filterDataInicio: string | null = null;
    public filterDataFim: string | null = null;
    public filterDataAtual = moment();

    public empresas: Array<Empresa>;
    public estabelecimentos: Array<Estabelecimento>;
    public listagemPermissao: Array<string> = ['visualizar_transferencias_vagas'];
    public permissaoGrupoEmpresarial = false;

    constructor(
        public $rootScope: angular.IRootScopeService & {
            temPermissaoGrupoEmpresarial: (permissoes: string[], grupo: string) => boolean,
            temPermissao: (arg: string) => boolean,
            session: any,
            nsjGlobals: any,
        },
        public $scope: angular.IScope,
        public $stateParams: angular.ui.IStateParamsService,
        public $location: angular.ILocationService,
        public NewToaster: { pop: Function },
        public entityService: MeurhTransferenciaColaboradoresService,
        public ListagemService: ListagemService
    ) {
        entityService.filter = $stateParams['q'] ? $stateParams['q'] : '';
        entityService.filters = {};
        entityService.constructors = {};

        this.permissaoGrupoEmpresarial = $rootScope.temPermissaoGrupoEmpresarial(
            this.listagemPermissao,
            $rootScope.nsjGlobals.a.grupoempresarial
        );

        this.filters = {
            ...this.filters,
            empresa: $rootScope.session.entities.empresa.empresa,
            estabelecimento: $rootScope.session.entities.estabelecimento.estabelecimento,
        };

        this.montaListagemVisibilidade();
        this.entities = this.filterReload();

        $rootScope.$on('meurh_solicitacoestransferenciasvagas_list_finished', () => {
            this.busy = false;
        });

        $rootScope.$on('meurh_solicitacoestransferenciasvagas_loaded', () => {
            this.busy = false;
        });

        $scope.$on('meurh_solicitacoestransferenciasvagas_submitted', () => {
            this.busy = false;
            this.entities = [];
            this.entities = this.entityService.reload();
        });

        $scope.$on('meurh_solicitacoestransferenciasvagas_deleted', () => {
            this.busy = false;
            this.entities = [];
            this.entities = this.entityService.reload();
        });
    }

    montaListagemVisibilidade() {
        this.empresas = this.ListagemService.montaEmpresas(this.$rootScope.nsjGlobals.a.grupoempresarial, this.listagemPermissao);
        this.estabelecimentos = this.ListagemService.montaEstabelecimentos(this.filters.empresa!, this.empresas, this.listagemPermissao);
    }

    mudaEstabelecimentos() {
        this.estabelecimentos = this.filters.empresa ? this.ListagemService.montaEstabelecimentos(this.filters.empresa, this.empresas, this.listagemPermissao) : [];
        this.filters.estabelecimento = '';
        this.filtraEmpresaEstabelecimento();
    }

    filtraEmpresaEstabelecimento() {
        delete this.filters.lotacao;
        this.$rootScope.$broadcast('lotacao_refresh', this.constructorEmpresaEstabelecimento());
        this.filterReload();
    }

    constructorEmpresaEstabelecimento() {
        return {
            'empresa': this.filters.empresa,
            'estabelecimento': this.filters.estabelecimento
        };
    }

    search(): Array<ITransferenciaColaboradores> {
        if (this.entityService.filter !== '') {
            this.$location.path(this.$location.path()).search(angular.extend({}, this.entityService.filters, { 'q': this.entityService.filter }));
        } else {
            this.$location.path(this.$location.path()).search(angular.extend({}, this.entityService.filters));
        }

        const filter = {
            search: this.entityService.filter,
            filters: angular.copy(this.entityService.filters)
        };
        return this.entityService.search(filter);
    }

    loadMore(): void {
        this.entityService.loadMore();
    }

    filterReload(): Array<ITransferenciaColaboradores> {
        const constructors: any = { ...this.filters };

        if (!this.valorExiste(constructors.lotacao)) {
            delete constructors.lotacao;
        } else {
            constructors.lotacao = constructors.lotacao.lotacao;
        }

        if (!this.valorExiste(constructors.situacao)) {
            delete constructors.situacao;
        }

        if (
            this.filterDataInicio !== null && this.filterDataFim !== null &&
            this.filterDataInicio !== '' && this.filterDataFim !== '' &&
            this.filterDataInicio > this.filterDataFim
        ) {
            this.NewToaster.pop({
                type: 'error',
                title: 'A data inícial não pode ser posterior a data final'
            });
            return [];
        }

        const created_at: { condition: string, value: string }[] = [];

        if (
            this.filterDataInicio === undefined ||
            (this.filterDataInicio !== null && this.filterDataInicio.length === 0)
        ) {
            this.filterDataInicio = null;
            constructors.datainicial = null;
        }

        if (this.filterDataInicio !== null) {
            created_at.push(
                {
                condition: 'gte',
                value: this.filterDataInicio + ' 00:00:00'
                }
            );
            delete constructors.datainicial;
        }

        if (
            this.filterDataFim === undefined ||
            (this.filterDataFim !== null && this.filterDataFim.length === 0)
        ) {
            this.filterDataFim = null;
            constructors.datafinal = null;
        }

        if (this.filterDataFim !== null) {
            created_at.push(
                {
                condition: 'lte',
                value: this.filterDataFim + ' 23:59:00'
                }
            );
            delete constructors.datafinal;
        }

        constructors.created_at = created_at;
        this.entityService.constructors = constructors;
        return this.entityService.reload();
    }

    isBusy(): boolean {
        return this.entityService.loadParams.busy;
    }

    valorExiste(valor: any): boolean {
        return valor !== '' && valor !== undefined && valor !== null ? true : false;
    }
}
